import React, { useState } from "react";
import { Modal, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import "../../../../assets/style/modalStyle/postNews.scss";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import { newsSelector } from "../../../../services/selector/index.";
import { validateUrl } from "../../../../utils/functionCommon";
import {
  createPostNews,
  setOpenModalAddNews,
} from "../../../../services/slice/NewsSlice";
import ModalPreviewPost from "../other/ModalPreviewPost";
import BaseButton from "../../Button/BaseButton";
import { IconEye, IconUpLoad } from "../../../../assets/icon";
import TabAddNews from "../../Tabs/TabAddNews";

const ModalPostNews = ({ title }) => {
  const [datapost, setDataPost] = useState({
    title: "",
    descriptions: "",
    content: "",
    typePost: 1,
    categories: 5,
  });
  const [error, setError] = useState({
    isError: false,
    msg: "",
  });
  const newsState = useSelector(newsSelector);
  const [image, setImage] = useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [openPreview, setOpenPreview] = useState(false);
  const handleSave = () => {
    const formPost = new FormData();
    if (
      !datapost.title ||
      datapost.content === "<p><br></p>" ||
      !datapost.content ||
      !datapost.descriptions ||
      !datapost.typePost ||
      !image
    ) {
      setError({
        isError: true,
        msg: "Vui lòng nhập đầy đủ thông tin",
      });
      return;
    }
    if (
      datapost.typePost === 2 &&
      datapost.content &&
      !validateUrl(datapost.content)
    ) {
      setError({
        isError: true,
        msg: "Đường dẫn không hợp lệ",
      });
      return;
    }
    // if (image.size > 2 * 1024 * 1024) {
    //   setError({
    //     isError: true,
    //     msg: "Dung lượng ảnh phải nhỏ hơn < 2MB",
    //   });
    //   return;
    // }

    setError({
      isError: false,
      msg: "",
    });
    formPost.append("title", datapost.title);
    formPost.append("categories", datapost.categories);
    formPost.append("descriptions", datapost.descriptions);
    formPost.append(
      "content",
      datapost.content.replace(
        new RegExp(window.SERVER_URL, "g"),
        window.SERVER_CLIENT_URL
      )
    );

    formPost.append("typePost", datapost.typePost);
    formPost.append(
      "smallImage",
      datapost.smallImage.type ? datapost.smallImage : ""
    );
    formPost.append(
      "largeImage",
      datapost.largeImage.type ? datapost.largeImage : ""
    );
    dispatch(createPostNews(formPost));
  };
  const handleCancel = () => {
    dispatch(setOpenModalAddNews(false));
  };

  const handleChangeTab = (key) => {
    setError({
      isError: false,
      msg: "",
    });
    if (key === "content") {
      setDataPost({
        ...datapost,
        content: "",
        typePost: 1,
      });
    } else
      setDataPost({
        ...datapost,
        content: "",
        typePost: 2,
      });
  };
  return (
    <>
      {openPreview && (
        <ModalPreviewPost
          open={openPreview}
          setOpen={setOpenPreview}
          data={datapost}
        />
      )}
      <Modal
        maskClosable={false}
        className="wrapperModalPostNews"
        title={t(title)}
        centered
        width={1300}
        open={newsState.isOpenModalAddNews}
        onCancel={handleCancel}
        footer={[
          <BaseButton
            content={"Xem trước"}
            width={175}
            typeBtn="btnOrange"
            icon={<IconEye fill="white" />}
            handleClick={() => (datapost.content ? setOpenPreview(true) : null)}
          />,
          <BaseButton
            content={"Đăng bài viết"}
            typeBtn="btnOrange"
            width={175}
            icon={<IconUpLoad />}
            handleClick={handleSave}
          />,
        ]}
      >
        <Tabs
          onChange={handleChangeTab}
          defaultActiveKey="content"
          items={[
            {
              label: t("Viết bài"),
              key: "content",
              children: (
                <TabAddNews
                  img={image}
                  error={error}
                  datapost={datapost}
                  setDataPost={setDataPost}
                  setImage={setImage}
                />
              ),
            },

            {
              label: t("Nhập link"),
              key: "link",
              children: (
                <TabAddNews
                  img={image}
                  error={error}
                  datapost={datapost}
                  setDataPost={setDataPost}
                  setImage={setImage}
                />
              ),
            },
          ]}
        />
      </Modal>
    </>
  );
};

export default ModalPostNews;
